/**
 * @deprecated This config-based approach has been replaced with dedicated display components.
 *
 * Use the new display components instead:
 * - CherryLineItemDisplay (src/components/LineItem/Display/CherryLineItemDisplay.jsx)
 * - TravelDocLineItemDisplay (src/components/LineItem/Display/TravelDocLineItemDisplay.jsx)
 * - TravelerAppLineItemDisplay (src/components/LineItem/Display/TravelerAppLineItemDisplay.jsx)
 * - LibraryPreviewLineItemDisplay (src/components/LineItem/Display/LibraryPreviewLineItemDisplay.jsx)
 *
 * These components provide better separation of concerns, easier maintenance, and
 * allow each view to have completely different HTML structures and layouts.
 *
 * Field order is now defined in src/components/LineItem/Display/shared/fieldOrder.js
 *
 * OLD LineItem Display Layout Configuration (DEPRECATED)
 * This is kept temporarily for backward compatibility but should not be used for new code.
 */
export const lineItemDisplayLayout = {
  HTL: {
    description: { row: 1, col: 1, colsize: 12 },
    vendorname: { row: 2, col: 1, colsize: 6, icon: 'Buildings' },
    startlocation: { row: 2, col: 7, colsize: 6, icon: 'MapPin' },
    vendorphone: { row: 3, col: 1, colsize: 6, icon: 'Phone' },
    vendorlink: {
      row: 3,
      col: 7,
      colsize: 6,
      label: 'Visit Website',
      icon: 'Globe',
      renderAs: 'link-only'
    },
    serviceclass: { row: 4, col: 1, colsize: 6, icon: 'Bed' },
    confirmationnumber: { row: 4, col: 7, colsize: 6, icon: 'Ticket' },
    startDate: {
      row: 5,
      col: 1,
      colsize: 4,
      label: 'Check-In Date',
      icon: 'CalendarCheck'
    },
    enddayoffset: { row: 5, col: 5, colsize: 4, icon: 'Moon' },
    endDate: {
      row: 5,
      col: 9,
      colsize: 4,
      label: 'Check-Out Date',
      icon: 'CalendarX'
    },
    starttime: {
      row: 7,
      col: 1,
      colsize: 4,
      label: 'Check-In Time',
      icon: 'Clock'
    },
    endtime: {
      row: 7,
      col: 9,
      colsize: 4,
      label: 'Check-Out Time',
      icon: 'Clock'
    },
    mealsincluded: { row: 8, col: 1, colsize: 12, icon: 'ForkKnife' }
  },
  ACT: {
    description: { row: 1, col: 1, colsize: 12 },
    contactname: { row: 2, col: 1, colsize: 4, icon: 'User' },
    vendorphone: { row: 2, col: 5, colsize: 4, icon: 'Phone' },
    startlocation: { row: 2, col: 9, colsize: 4, icon: 'MapPin' },
    starttime: { row: 3, col: 1, colsize: 4, icon: 'Clock' },
    durationtime: { row: 3, col: 5, colsize: 4, icon: 'Hourglass' },
    confirmationnumber: { row: 3, col: 9, colsize: 4, icon: 'Ticket' },
    vendorlink: {
      row: 4,
      col: 1,
      colsize: 4,
      label: 'Visit Website',
      icon: 'Globe',
      renderAs: 'link-only'
    },
    mealsincluded: { row: 4, col: 5, colsize: 8, icon: 'ForkKnife' }
  },
  CAR: {
    description: { row: 1, col: 1, colsize: 12 },
    vendorname: {
      row: 2,
      col: 1,
      colsize: 4,
      label: 'Company',
      icon: 'Buildings'
    },
    serviceclass: {
      row: 2,
      col: 5,
      colsize: 4,
      label: 'Car Type',
      icon: 'Car'
    },
    startlocation: {
      row: 2,
      col: 9,
      colsize: 4,
      label: 'Pick-up Location',
      icon: 'MapPin'
    },
    startDate: {
      row: 3,
      col: 1,
      colsize: 4,
      label: 'Pick-up Date',
      icon: 'CalendarCheck'
    },
    starttime: {
      row: 3,
      col: 5,
      colsize: 4,
      label: 'Pick-up Time',
      icon: 'Clock'
    },
    endDate: {
      row: 3,
      col: 9,
      colsize: 4,
      label: 'Drop-off Date',
      icon: 'CalendarX'
    },
    endtime: {
      row: 4,
      col: 1,
      colsize: 4,
      label: 'Drop-off Time',
      icon: 'Clock'
    },
    endlocation: {
      row: 4,
      col: 5,
      colsize: 4,
      label: 'Drop-off Location',
      icon: 'MapPin'
    },
    confirmationnumber: { row: 4, col: 9, colsize: 4, icon: 'Ticket' }
  },
  FLT: {
    description: { row: 1, col: 1, colsize: 12 },
    vendorname: { row: 2, col: 1, colsize: 4, icon: 'AirplaneTilt' },
    servicenumber: { row: 2, col: 5, colsize: 4, icon: 'Airplane' },
    confirmationnumber: { row: 2, col: 9, colsize: 4, icon: 'Ticket' },
    startDate: {
      row: 3,
      col: 1,
      colsize: 4,
      label: 'Departure Date',
      icon: 'CalendarCheck'
    },
    startlocation: { row: 3, col: 5, colsize: 4, icon: 'AirplaneTakeoff' },
    starttime: {
      row: 3,
      col: 9,
      colsize: 4,
      label: 'Departure Time',
      icon: 'Clock'
    },
    endDate: {
      row: 4,
      col: 1,
      colsize: 4,
      label: 'Arrival Date',
      icon: 'CalendarX'
    },
    endlocation: { row: 4, col: 5, colsize: 4, icon: 'AirplaneLanding' },
    endtime: {
      row: 4,
      col: 9,
      colsize: 4,
      label: 'Arrival Time',
      icon: 'Clock'
    }
  },
  RST: {
    description: { row: 1, col: 1, colsize: 12 },
    vendorname: { row: 2, col: 1, colsize: 4, icon: 'ForkKnife' },
    vendorphone: { row: 2, col: 5, colsize: 4, icon: 'Phone' },
    startlocation: { row: 2, col: 9, colsize: 4, icon: 'MapPin' },
    confirmationnumber: { row: 3, col: 1, colsize: 4, icon: 'Ticket' },
    vendorlink: {
      row: 3,
      col: 5,
      colsize: 4,
      label: 'Visit Website',
      icon: 'Globe',
      renderAs: 'link-only'
    },
    mealsincluded: { row: 8, col: 1, colsize: 12, icon: 'ForkKnife' }
  },
  TRF: {
    description: { row: 1, col: 1, colsize: 12 },
    vendorname: { row: 2, col: 1, colsize: 4, label: 'Company', icon: 'Van' },
    contactname: { row: 2, col: 5, colsize: 4, icon: 'User' },
    vendorphone: {
      row: 2,
      col: 9,
      colsize: 4,
      label: 'Phone Number',
      icon: 'Phone'
    },
    startDate: {
      row: 3,
      col: 1,
      colsize: 4,
      label: 'Pick-up Date',
      icon: 'CalendarCheck'
    },
    starttime: {
      row: 3,
      col: 5,
      colsize: 4,
      label: 'Pick-up Time',
      icon: 'Clock'
    },
    startlocation: {
      row: 3,
      col: 9,
      colsize: 4,
      label: 'Pick-up Location',
      icon: 'MapPin'
    },
    endDate: {
      row: 4,
      col: 1,
      colsize: 4,
      label: 'Drop-off Date',
      icon: 'CalendarX'
    },
    endtime: {
      row: 4,
      col: 5,
      colsize: 4,
      label: 'Drop-off Time',
      icon: 'Clock'
    },
    endlocation: {
      row: 4,
      col: 9,
      colsize: 4,
      label: 'Drop-off Location',
      icon: 'MapPin'
    },
    confirmationnumber: { row: 5, col: 1, colsize: 4, icon: 'Ticket' },
    vendorlink: {
      row: 5,
      col: 5,
      colsize: 4,
      label: 'Visit Website',
      icon: 'Globe',
      renderAs: 'link-only'
    }
  },
  TRN: {
    description: { row: 1, col: 1, colsize: 12 },
    vendorname: { row: 2, col: 1, colsize: 4, icon: 'Train' },
    servicenumber: { row: 2, col: 5, colsize: 4, icon: 'Hash' },
    startlocation: {
      row: 2,
      col: 9,
      colsize: 4,
      label: 'Departure Station',
      icon: 'MapPin'
    },
    startDate: {
      row: 3,
      col: 1,
      colsize: 4,
      label: 'Departure Date',
      icon: 'CalendarCheck'
    },
    starttime: {
      row: 3,
      col: 5,
      colsize: 4,
      label: 'Departure Time',
      icon: 'Clock'
    },
    endDate: {
      row: 3,
      col: 9,
      colsize: 4,
      label: 'Arrival Date',
      icon: 'CalendarX'
    },
    endlocation: {
      row: 4,
      col: 1,
      colsize: 4,
      label: 'Arrival Station',
      icon: 'MapPin'
    },
    endtime: {
      row: 4,
      col: 5,
      colsize: 4,
      label: 'Arrival Time',
      icon: 'Clock'
    },
    confirmationnumber: { row: 4, col: 9, colsize: 4, icon: 'Ticket' }
  }
};

/**
 * LineItem Form Field Configuration
 *
 * Defines the form fields for each service type code based on the migration mapping:
 * XG-DB/==Migrations/Migrations_20260120_Service_LineItem_Mapping.md
 *
 * Each field definition includes:
 * - field: LineItem column name
 * - label: Display label for the field
 * - type: Field type (text, textarea, time, number, phone, url, checkbox, image, file)
 * - required: Whether the field is required
 * - seq: Display sequence order (for editor)
 * - row, col, colsize: Editor layout properties
 * - accordion: Whether to render in an accordion (for internal notes)
 * - tripOnly: Whether this field should be shown only on Trip LineItems, and not shown on Library LineItems
 *
 * Note: Display/preview layout is now managed separately in lineItemDisplayLayout.
 * Any showInPreview, preview* properties here are deprecated and will be ignored.
 */

export const lineItemFieldConfig = {
  // HTL - Hotel/Accommodation
  HTL: [
    {
      field: 'title',
      label: 'Title',
      type: 'text',
      required: true,
      tripOnly: false,
      seq: 1,
      row: 1,
      col: 1,
      colsize: 12,
      placeholder: 'Enter title',
      maxLength: 250
    },
    {
      field: 'description',
      label: 'Description',
      type: 'textarea',
      required: false,
      tripOnly: false,
      seq: 2,
      row: 2,
      col: 1,
      colsize: 12,
      placeholder: 'Enter description'
    },
    {
      field: 'vendorname',
      label: 'Hotel',
      type: 'text',
      required: false,
      tripOnly: false,
      seq: 3,
      row: 3,
      col: 1,
      colsize: 6,
      placeholder: 'Hotel name',
      maxLength: 250
    },
    {
      field: 'vendorphone',
      label: 'Phone',
      type: 'phone',
      required: false,
      tripOnly: false,
      seq: 4,
      row: 3,
      col: 7,
      colsize: 6
    },
    {
      field: 'startlocation',
      label: 'Address',
      type: 'text',
      required: false,
      tripOnly: false,
      seq: 5,
      row: 4,
      col: 1,
      colsize: 12,
      placeholder: 'Enter address',
      maxLength: 250
    },
    {
      field: 'starttime',
      label: 'Check-In Time',
      type: 'time',
      required: false,
      tripOnly: false,
      seq: 6,
      row: 5,
      col: 1,
      colsize: 4
    },
    {
      field: 'endtime',
      label: 'Check-Out Time',
      type: 'time',
      required: false,
      tripOnly: false,
      seq: 7,
      row: 5,
      col: 5,
      colsize: 4
    },
    {
      field: 'enddayoffset',
      label: '# of Nights',
      type: 'number',
      required: false,
      tripOnly: false,
      seq: 8,
      row: 5,
      col: 9,
      colsize: 4,
      placeholder: 'Set # of nights',
      maxLength: 250
    },
    {
      field: 'serviceclass',
      label: 'Room',
      type: 'text',
      required: false,
      tripOnly: false,
      seq: 9,
      row: 6,
      col: 1,
      colsize: 12,
      placeholder: 'Room type',
      maxLength: 250
    },
    {
      field: 'confirmationnumber',
      label: 'Confirmation',
      type: 'text',
      required: false,
      tripOnly: true,
      seq: 10,
      row: 7,
      col: 1,
      colsize: 6,
      placeholder: 'Enter info',
      maxLength: 250
    },
    {
      field: 'vendorlink',
      label: 'Link',
      type: 'url',
      required: false,
      tripOnly: false,
      seq: 11,
      row: 7,
      col: 7,
      colsize: 6,
      placeholder: 'Link',
      maxLength: 250
    },
    {
      field: 'mealsincluded',
      label: 'Meals Included',
      type: 'checkbox',
      required: false,
      tripOnly: false,
      seq: 12,
      row: 8,
      col: 1,
      colsize: 6
    },
    {
      field: 'images',
      label: 'Add Image',
      type: 'image',
      required: false,
      tripOnly: false,
      seq: 13,
      row: 9,
      col: 1,
      colsize: 12
    },
    {
      field: 'attachments',
      label: 'Add Attachment',
      type: 'file',
      required: false,
      tripOnly: false,
      seq: 14,
      row: 10,
      col: 1,
      colsize: 12
    },
    {
      field: 'internalnote',
      label: 'Internal Notes',
      type: 'textarea',
      required: false,
      tripOnly: false,
      seq: 15,
      accordion: true,
      row: 11,
      col: 1,
      colsize: 12
    }
  ],

  // ACT - Activity
  ACT: [
    {
      field: 'title',
      label: 'Title',
      type: 'text',
      required: true,
      seq: 1,
      row: 1,
      col: 1,
      colsize: 12,
      placeholder: 'Enter title',
      maxLength: 250
    },
    {
      field: 'description',
      label: 'Description',
      type: 'textarea',
      required: false,
      tripOnly: false,
      seq: 2,
      row: 2,
      col: 1,
      colsize: 12,
      placeholder: 'Enter description'
    },
    {
      field: 'vendorname',
      label: 'Provider Name',
      type: 'text',
      required: false,
      tripOnly: false,
      seq: 3,
      row: 3,
      col: 1,
      colsize: 6,
      placeholder: 'Enter provider name',
      maxLength: 250
    },
    {
      field: 'vendorphone',
      label: 'Phone',
      type: 'phone',
      required: false,
      tripOnly: false,
      seq: 4,
      row: 3,
      col: 7,
      colsize: 6
    },
    {
      field: 'startlocation',
      label: 'Address',
      type: 'text',
      required: false,
      tripOnly: false,
      seq: 5,
      row: 4,
      col: 1,
      colsize: 12,
      placeholder: 'Enter address',
      maxLength: 250
    },
    {
      field: 'starttime',
      label: 'Start Time',
      type: 'time',
      required: false,
      tripOnly: false,
      seq: 6,
      row: 5,
      col: 1,
      colsize: 6
    },
    {
      field: 'durationtime',
      label: 'Duration',
      type: 'duration',
      required: false,
      tripOnly: false,
      seq: 7,
      row: 5,
      col: 7,
      colsize: 6
    },
    {
      field: 'confirmationnumber',
      label: 'Confirmation',
      type: 'text',
      required: false,
      tripOnly: true,
      seq: 8,
      row: 6,
      col: 1,
      colsize: 6,
      placeholder: 'Enter info',
      maxLength: 250
    },
    {
      field: 'vendorlink',
      label: 'Link',
      type: 'url',
      required: false,
      tripOnly: false,
      seq: 9,
      row: 6,
      col: 7,
      colsize: 6,
      placeholder: 'Link',
      maxLength: 250
    },
    {
      field: 'mealsincluded',
      label: 'Meals Included',
      type: 'checkbox',
      required: false,
      tripOnly: false,
      seq: 10,
      row: 7,
      col: 1,
      colsize: 12
    },
    {
      field: 'images',
      label: 'Add Image',
      type: 'image',
      required: false,
      tripOnly: false,
      seq: 11,
      row: 8,
      col: 1,
      colsize: 12
    },
    {
      field: 'attachments',
      label: 'Add Attachment',
      type: 'file',
      required: false,
      tripOnly: false,
      seq: 12,
      row: 9,
      col: 1,
      colsize: 12
    },
    {
      field: 'internalnote',
      label: 'Internal Notes',
      type: 'textarea',
      required: false,
      tripOnly: false,
      seq: 13,
      accordion: true,
      row: 10,
      col: 1,
      colsize: 12
    }
  ],

  // CAR - Car Rental
  CAR: [
    {
      field: 'title',
      label: 'Title',
      type: 'text',
      required: true,
      seq: 1,
      row: 1,
      col: 1,
      colsize: 12,
      placeholder: 'Enter title',
      maxLength: 250
    },
    {
      field: 'description',
      label: 'Description',
      type: 'textarea',
      required: false,
      tripOnly: false,
      seq: 2,
      row: 2,
      col: 1,
      colsize: 12,
      placeholder: 'Enter description'
    },
    {
      field: 'vendorname',
      label: 'Rental Company',
      type: 'text',
      required: false,
      tripOnly: false,
      seq: 3,
      row: 3,
      col: 1,
      colsize: 6,
      placeholder: 'Enter company name',
      maxLength: 250
    },
    {
      field: 'serviceclass',
      label: 'Car Class',
      type: 'text',
      required: false,
      tripOnly: false,
      seq: 4,
      row: 3,
      col: 7,
      colsize: 6,
      placeholder: 'Enter class',
      maxLength: 250
    },
    {
      field: 'starttime',
      label: 'Pick Up Time',
      type: 'time',
      required: false,
      tripOnly: false,
      seq: 5,
      row: 4,
      col: 1,
      colsize: 4
    },
    {
      field: 'endtime',
      label: 'Drop Off Time',
      type: 'time',
      required: false,
      tripOnly: false,
      seq: 6,
      row: 4,
      col: 5,
      colsize: 4
    },
    {
      field: 'enddayoffset',
      label: '# of days',
      type: 'number',
      required: false,
      tripOnly: false,
      seq: 7,
      row: 4,
      col: 9,
      colsize: 4,
      placeholder: 'Set # of days',
      maxLength: 250
    },
    {
      field: 'startlocation',
      label: 'Pick Up Address',
      type: 'text',
      required: false,
      tripOnly: false,
      seq: 8,
      row: 5,
      col: 1,
      colsize: 6,
      placeholder: 'Enter address',
      maxLength: 250
    },
    {
      field: 'endlocation',
      label: 'Drop Off Address',
      type: 'text',
      required: false,
      tripOnly: false,
      seq: 9,
      row: 5,
      col: 7,
      colsize: 6,
      placeholder: 'Enter address',
      maxLength: 250
    },
    {
      field: 'confirmationnumber',
      label: 'Confirmation',
      type: 'text',
      required: false,
      tripOnly: true,
      seq: 10,
      row: 6,
      col: 1,
      colsize: 12,
      placeholder: 'Enter info',
      maxLength: 250
    },
    {
      field: 'images',
      label: 'Add Image',
      type: 'image',
      required: false,
      tripOnly: false,
      seq: 11,
      row: 7,
      col: 1,
      colsize: 12
    },
    {
      field: 'attachments',
      label: 'Add Attachment',
      type: 'file',
      required: false,
      tripOnly: false,
      seq: 12,
      row: 8,
      col: 1,
      colsize: 12
    },
    {
      field: 'internalnote',
      label: 'Internal Notes',
      type: 'textarea',
      required: false,
      tripOnly: false,
      seq: 13,
      accordion: true,
      row: 9,
      col: 1,
      colsize: 12
    }
  ],

  // FLT - Flight
  FLT: [
    {
      field: 'title',
      label: 'Title',
      type: 'text',
      required: true,
      seq: 1,
      row: 1,
      col: 1,
      colsize: 12,
      placeholder: 'Enter title',
      maxLength: 250
    },
    {
      field: 'description',
      label: 'Description',
      type: 'textarea',
      required: false,
      tripOnly: false,
      seq: 2,
      row: 2,
      col: 1,
      colsize: 12,
      placeholder: 'Enter description'
    },
    {
      field: 'vendorname',
      label: 'Airline',
      type: 'text',
      required: false,
      tripOnly: false,
      seq: 3,
      row: 3,
      col: 1,
      colsize: 6,
      placeholder: 'Enter airline',
      maxLength: 250
    },
    {
      field: 'servicenumber',
      label: 'Flight Number',
      type: 'text',
      required: false,
      tripOnly: true,
      seq: 4,
      row: 3,
      col: 7,
      colsize: 6,
      placeholder: '#',
      maxLength: 250
    },
    {
      field: 'startlocation',
      label: 'Departure Airport',
      type: 'text',
      required: false,
      tripOnly: false,
      seq: 5,
      row: 4,
      col: 1,
      colsize: 6,
      placeholder: 'Enter address',
      maxLength: 250
    },
    {
      field: 'endlocation',
      label: 'Arrival Airport',
      type: 'text',
      required: false,
      tripOnly: false,
      seq: 6,
      row: 4,
      col: 7,
      colsize: 6,
      placeholder: 'Enter address',
      maxLength: 250
    },
    {
      field: 'starttime',
      label: 'Departure Time',
      type: 'time',
      required: false,
      tripOnly: true,
      seq: 7,
      row: 5,
      col: 1,
      colsize: 4
    },
    {
      field: 'endtime',
      label: 'Arrival Time',
      type: 'time',
      required: false,
      tripOnly: true,
      seq: 8,
      row: 5,
      col: 5,
      colsize: 4
    },
    {
      field: 'arrivesnextday',
      label: 'Next Day Arrival',
      type: 'boolean',
      required: false,
      tripOnly: true,
      seq: 9,
      row: 5,
      col: 9,
      colsize: 4
    },
    {
      field: 'confirmationnumber',
      label: 'Confirmation',
      type: 'text',
      required: false,
      tripOnly: true,
      seq: 10,
      row: 6,
      col: 1,
      colsize: 12,
      placeholder: 'Enter info',
      maxLength: 250
    },
    {
      field: 'images',
      label: 'Add Image',
      type: 'image',
      required: false,
      tripOnly: false,
      seq: 11,
      row: 7,
      col: 1,
      colsize: 12
    },
    {
      field: 'attachments',
      label: 'Add Attachment',
      type: 'file',
      required: false,
      tripOnly: false,
      seq: 12,
      row: 8,
      col: 1,
      colsize: 12
    },
    {
      field: 'internalnote',
      label: 'Internal Notes',
      type: 'textarea',
      required: false,
      tripOnly: false,
      seq: 13,
      accordion: true,
      row: 9,
      col: 1,
      colsize: 12
    }
  ],

  // RST - Restaurant
  RST: [
    {
      field: 'title',
      label: 'Title',
      type: 'text',
      required: true,
      seq: 1,
      row: 1,
      col: 1,
      colsize: 12,
      placeholder: 'Enter title',
      maxLength: 250
    },
    {
      field: 'description',
      label: 'Description',
      type: 'textarea',
      required: false,
      tripOnly: false,
      seq: 2,
      row: 2,
      col: 1,
      colsize: 12,
      placeholder: 'Enter description'
    },
    {
      field: 'vendorname',
      label: 'Restaurant',
      type: 'text',
      required: false,
      tripOnly: false,
      seq: 3,
      row: 3,
      col: 1,
      colsize: 6,
      placeholder: 'Restaurant name',
      maxLength: 250
    },
    {
      field: 'vendorphone',
      label: 'Phone',
      type: 'phone',
      required: false,
      tripOnly: false,
      seq: 4,
      row: 3,
      col: 7,
      colsize: 6
    },
    {
      field: 'startlocation',
      label: 'Address',
      type: 'text',
      required: false,
      tripOnly: false,
      seq: 5,
      row: 4,
      col: 1,
      colsize: 12,
      placeholder: 'Enter address',
      maxLength: 250
    },
    {
      field: 'starttime',
      label: 'Start Time',
      type: 'time',
      required: false,
      tripOnly: false,
      seq: 6,
      row: 5,
      col: 1,
      colsize: 4
    },
    {
      field: 'confirmationnumber',
      label: 'Confirmation',
      type: 'text',
      required: false,
      tripOnly: true,
      seq: 7,
      row: 5,
      col: 5,
      colsize: 4,
      placeholder: 'Enter info',
      maxLength: 250
    },
    {
      field: 'vendorlink',
      label: 'Link',
      type: 'url',
      required: false,
      tripOnly: false,
      seq: 8,
      row: 5,
      col: 9,
      colsize: 4,
      placeholder: 'Link',
      maxLength: 250
    },
    {
      field: 'mealsincluded',
      label: 'Meals Included',
      type: 'checkbox',
      required: false,
      tripOnly: false,
      seq: 9,
      row: 6,
      col: 9,
      colsize: 6
    },
    {
      field: 'images',
      label: 'Add Image',
      type: 'image',
      required: false,
      tripOnly: false,
      seq: 10,
      row: 7,
      col: 1,
      colsize: 12
    },
    {
      field: 'attachments',
      label: 'Add Attachment',
      type: 'file',
      required: false,
      tripOnly: false,
      seq: 10,
      row: 8,
      col: 1,
      colsize: 12
    },
    {
      field: 'internalnote',
      label: 'Internal Notes',
      type: 'textarea',
      required: false,
      tripOnly: false,
      seq: 11,
      accordion: true,
      row: 9,
      col: 1,
      colsize: 12
    }
  ],

  // TRF - Transfer
  TRF: [
    {
      field: 'title',
      label: 'Title',
      type: 'text',
      required: true,
      seq: 1,
      row: 1,
      col: 1,
      colsize: 12,
      placeholder: 'Enter title',
      maxLength: 250
    },
    {
      field: 'description',
      label: 'Description',
      type: 'textarea',
      required: false,
      tripOnly: false,
      seq: 2,
      row: 2,
      col: 1,
      colsize: 12,
      placeholder: 'Enter description'
    },
    {
      field: 'vendorname',
      label: 'Company Name',
      type: 'text',
      required: false,
      tripOnly: false,
      seq: 3,
      row: 3,
      col: 1,
      colsize: 6,
      placeholder: 'Enter company name',
      maxLength: 250
    },
    {
      field: 'contactname',
      label: 'Driver Name',
      type: 'text',
      required: false,
      tripOnly: false,
      seq: 4,
      row: 3,
      col: 7,
      colsize: 6,
      placeholder: "Enter driver's name",
      maxLength: 250
    },
    {
      field: 'vendorphone',
      label: 'Phone',
      type: 'phone',
      required: false,
      tripOnly: false,
      seq: 5,
      row: 4,
      col: 1,
      colsize: 12
    },
    {
      field: 'starttime',
      label: 'Pick Up Time',
      type: 'time',
      required: false,
      tripOnly: false,
      seq: 6,
      row: 5,
      col: 1,
      colsize: 6
    },
    {
      field: 'endtime',
      label: 'Drop Off Time',
      type: 'time',
      required: false,
      tripOnly: false,
      seq: 7,
      row: 5,
      col: 7,
      colsize: 6
    },
    {
      field: 'startlocation',
      label: 'Pick Up Address',
      type: 'text',
      required: false,
      tripOnly: false,
      seq: 8,
      row: 6,
      col: 1,
      colsize: 6,
      placeholder: 'Enter address',
      maxLength: 250
    },
    {
      field: 'endlocation',
      label: 'Drop Off Address',
      type: 'text',
      required: false,
      tripOnly: false,
      seq: 9,
      row: 6,
      col: 7,
      colsize: 6,
      placeholder: 'Enter address',
      maxLength: 250
    },
    {
      field: 'confirmationnumber',
      label: 'Confirmation',
      type: 'text',
      required: false,
      tripOnly: true,
      seq: 10,
      row: 7,
      col: 1,
      colsize: 6,
      placeholder: 'Enter info',
      maxLength: 250
    },
    {
      field: 'vendorlink',
      label: 'Link',
      type: 'url',
      required: false,
      tripOnly: false,
      seq: 11,
      row: 7,
      col: 7,
      colsize: 6,
      placeholder: 'Link',
      maxLength: 250
    },
    {
      field: 'images',
      label: 'Add Image',
      type: 'image',
      required: false,
      tripOnly: false,
      seq: 12,
      row: 9,
      col: 1,
      colsize: 12
    },
    {
      field: 'attachments',
      label: 'Add Attachment',
      type: 'file',
      required: false,
      tripOnly: false,
      seq: 13,
      row: 10,
      col: 1,
      colsize: 12
    },
    {
      field: 'internalnote',
      label: 'Internal Notes',
      type: 'textarea',
      required: false,
      tripOnly: false,
      seq: 14,
      accordion: true,
      row: 11,
      col: 1,
      colsize: 12
    }
  ],

  // TRN - Train
  TRN: [
    {
      field: 'title',
      label: 'Title',
      type: 'text',
      required: true,
      seq: 1,
      row: 1,
      col: 1,
      colsize: 12,
      placeholder: 'Enter title',
      maxLength: 250
    },
    {
      field: 'description',
      label: 'Description',
      type: 'textarea',
      required: false,
      tripOnly: false,
      seq: 2,
      row: 2,
      col: 1,
      colsize: 12,
      placeholder: 'Enter description'
    },
    {
      field: 'vendorname',
      label: 'Train Company',
      type: 'text',
      required: false,
      tripOnly: false,
      seq: 3,
      row: 3,
      col: 1,
      colsize: 6,
      placeholder: 'Enter company name',
      maxLength: 250
    },
    {
      field: 'servicenumber',
      label: 'Train Number',
      type: 'text',
      required: false,
      tripOnly: true,
      seq: 4,
      row: 3,
      col: 7,
      colsize: 6,
      placeholder: '#',
      maxLength: 250
    },
    {
      field: 'startlocation',
      label: 'Departure Station',
      type: 'text',
      required: false,
      tripOnly: false,
      seq: 5,
      row: 4,
      col: 1,
      colsize: 6,
      placeholder: 'Enter address',
      maxLength: 250
    },
    {
      field: 'endlocation',
      label: 'Arrival Station',
      type: 'text',
      required: false,
      tripOnly: false,
      seq: 6,
      row: 4,
      col: 7,
      colsize: 6,
      placeholder: 'Enter address',
      maxLength: 250
    },
    {
      field: 'starttime',
      label: 'Departure Time',
      type: 'time',
      required: false,
      tripOnly: true,
      seq: 7,
      row: 5,
      col: 1,
      colsize: 4
    },
    {
      field: 'endtime',
      label: 'Arrival Time',
      type: 'time',
      required: false,
      tripOnly: true,
      seq: 8,
      row: 5,
      col: 5,
      colsize: 4
    },
    {
      field: 'arrivesnextday',
      label: 'Next Day Arrival',
      type: 'boolean',
      required: false,
      tripOnly: true,
      seq: 9,
      row: 5,
      col: 9,
      colsize: 4
    },
    {
      field: 'confirmationnumber',
      label: 'Confirmation',
      type: 'text',
      required: false,
      tripOnly: true,
      seq: 10,
      row: 6,
      col: 1,
      colsize: 12,
      placeholder: 'Enter info',
      maxLength: 250
    },
    {
      field: 'images',
      label: 'Add Image',
      type: 'image',
      required: false,
      tripOnly: false,
      seq: 11,
      row: 7,
      col: 1,
      colsize: 12
    },
    {
      field: 'attachments',
      label: 'Add Attachment',
      type: 'file',
      required: false,
      tripOnly: false,
      seq: 12,
      row: 8,
      col: 1,
      colsize: 12
    },
    {
      field: 'internalnote',
      label: 'Internal Notes',
      type: 'textarea',
      required: false,
      tripOnly: false,
      seq: 13,
      accordion: true,
      row: 9,
      col: 1,
      colsize: 12
    }
  ],

  // INF - Info
  INF: [
    {
      field: 'title',
      label: 'Title',
      type: 'text',
      required: true,
      tripOnly: false,
      seq: 1,
      row: 1,
      col: 1,
      colsize: 12,
      placeholder: 'Enter title',
      maxLength: 300
    },
    {
      field: 'description',
      label: 'Description',
      type: 'textarea',
      required: false,
      tripOnly: false,
      seq: 2,
      row: 2,
      col: 1,
      colsize: 12,
      placeholder: 'Enter description'
    },
    {
      field: 'vendorlink',
      label: 'Link',
      type: 'url',
      required: false,
      tripOnly: false,
      seq: 3,
      row: 3,
      col: 1,
      colsize: 12,
      placeholder: 'Enter link',
      maxLength: 250
    },
    {
      field: 'images',
      label: 'Add Image',
      type: 'image',
      required: false,
      tripOnly: false,
      seq: 4,
      row: 4,
      col: 1,
      colsize: 12
    },
    {
      field: 'attachments',
      label: 'Add Attachment',
      type: 'file',
      required: false,
      tripOnly: false,
      seq: 5,
      row: 5,
      col: 1,
      colsize: 12
    },
    {
      field: 'internalnote',
      label: 'Internal Notes',
      type: 'textarea',
      required: false,
      tripOnly: false,
      seq: 6,
      accordion: true,
      row: 6,
      col: 1,
      colsize: 12
    }
  ]
};

//Defines the fields order for each lineItem type on the cherry template
export const lineItemsCherryOrder = {
  // HTL - Hotel/Accommodation
  HTL: [
    {
      field: 'title',
      label: 'Title',
      seq: 1
    },
    {
      field: 'images',
      label: 'Add Image',
      seq: 2
    },
    {
      field: 'description',
      seq: 3
    },
    {
      field: 'vendorname',
      label: 'Hotel',
      seq: 4
    },
    {
      field: 'vendorlink',
      label: 'Link',
      seq: 5
    },
    {
      field: 'serviceclass',
      label: 'Room',
      seq: 6
    },
    {
      field: 'mealsincluded',
      label: 'Meals Included',
      seq: 7
    },
    {
      field: 'checkInDate', //Custom
      label: 'Check-In Date',
      seq: 8
    },
    {
      field: 'checkOutDate', //Custom
      label: 'Check-Out Date',
      seq: 9
    },
    {
      field: 'enddayoffset',
      label: '# of Nights',
      seq: 10
    },
    {
      field: 'vendorphone',
      label: 'Phone',
      seq: 11
    },
    {
      field: 'startlocation',
      label: 'Address',
      seq: 12
    },
    {
      field: 'attachments',
      label: 'Add Attachment',
      seq: 13
    },
    {
      field: 'confirmationnumber',
      label: 'Confirmation',
      seq: 14
    }
  ],
  // TRF - Transfer
  TRF: [
    {
      field: 'title',
      label: 'Title',
      seq: 1
    },
    {
      field: 'images',
      label: 'Add Image',
      seq: 2
    },
    {
      field: 'description',
      label: 'Description',
      seq: 3
    },
    {
      field: 'vendorname',
      label: 'Company Name',
      seq: 4
    },
    {
      field: 'startlocation',
      label: 'Pick Up Address',
      seq: 5
    },
    {
      field: 'starttime',
      label: 'Pick Up Time',
      seq: 6
    },
    {
      field: 'endlocation',
      label: 'Drop Off Address',
      seq: 7
    },
    {
      field: 'endtime',
      label: 'Drop Off Time',
      seq: 8
    },
    {
      field: 'contactname',
      label: 'Driver Name',
      seq: 9
    },
    {
      field: 'vendorphone',
      label: 'Phone',
      seq: 10
    },
    {
      field: 'attachments',
      label: 'Add Attachment',
      seq: 11
    },
    {
      field: 'confirmationnumber',
      label: 'Confirmation',
      seq: 12
    },
    {
      field: 'vendorlink',
      label: 'Link',
      seq: 13
    }
  ],
  // ACT - Activity
  ACT: [
    {
      field: 'title',
      label: 'Title',
      seq: 1
    },
    {
      field: 'images',
      label: 'Add Image',
      seq: 2
    },
    {
      field: 'description',
      label: 'Description',
      seq: 3
    },
    {
      field: 'vendorname',
      label: 'Provider Name',
      seq: 4
    },
    {
      field: 'vendorlink',
      label: 'Link',
      seq: 5
    },
    {
      field: 'durationtime',
      label: 'Duration',
      seq: 6
    },
    {
      field: 'starttime',
      label: 'Start Time',
      seq: 7
    },
    {
      field: 'mealsincluded',
      label: 'Meals Included',
      seq: 8
    },
    {
      field: 'vendorphone',
      label: 'Phone',
      seq: 9
    },
    {
      field: 'startlocation',
      label: 'Address',
      seq: 10
    },
    {
      field: 'attachments',
      label: 'Add Attachment',
      seq: 11
    },

    {
      field: 'confirmationnumber',
      label: 'Confirmation',
      seq: 12
    }
  ],
  // FLT - Flight
  FLT: [
    {
      field: 'title',
      label: 'Title',
      seq: 1
    },
    {
      field: 'description',
      label: 'Description',
      seq: 2
    },
    {
      field: 'images',
      label: 'Add Image',
      seq: 3
    },
    {
      field: 'vendorname',
      label: 'Airline',
      seq: 4
    },
    {
      field: 'servicenumber',
      label: 'Flight Number',
      seq: 5
    },
    {
      field: 'startlocation',
      label: 'Departure Airport',
      seq: 6
    },
    {
      field: 'starttime',
      label: 'Departure Time',
      type: 'time',
      seq: 7
    },
    {
      field: 'endlocation',
      label: 'Arrival Airport',
      seq: 8
    },
    {
      field: 'endtime',
      label: 'Arrival Time',
      seq: 9
    },
    {
      field: 'attachments',
      label: 'Add Attachment',
      seq: 10
    },
    {
      field: 'confirmationnumber',
      label: 'Confirmation',
      seq: 11
    },
    {
      field: 'arrivesnextday',
      label: 'Next Day Arrival',
      seq: 13
    }
  ],
  // RST - Restaurant
  RST: [
    {
      field: 'title',
      label: 'Title',
      seq: 1
    },
    {
      field: 'images',
      label: 'Add Image',
      seq: 2
    },
    {
      field: 'description',
      label: 'Description',
      seq: 3
    },
    {
      field: 'vendorname',
      label: 'Restaurant',
      seq: 4
    },
    {
      field: 'vendorlink',
      label: 'Link',
      seq: 5
    },
    {
      field: 'starttime',
      label: 'Start Time',
      seq: 6
    },
    {
      field: 'mealsincluded',
      label: 'Meals Included',
      seq: 7
    },
    {
      field: 'vendorphone',
      label: 'Phone',
      seq: 8
    },
    {
      field: 'startlocation',
      label: 'Address',
      seq: 9
    },
    {
      field: 'attachments',
      label: 'Add Attachment',
      seq: 10
    },

    {
      field: 'confirmationnumber',
      label: 'Confirmation',
      seq: 11
    }
  ],
  // CAR - Car Rental
  CAR: [
    {
      field: 'title',
      label: 'Title',
      seq: 1
    },
    {
      field: 'images',
      label: 'Add Image',
      seq: 2
    },
    {
      field: 'description',
      label: 'Description',
      seq: 3
    },
    {
      field: 'vendorname',
      label: 'Rental Company',
      seq: 4
    },
    {
      field: 'serviceclass',
      label: 'Car Class',
      seq: 5
    },
    {
      field: 'startlocation',
      label: 'Pick Up Address',
      seq: 6
    },
    {
      field: 'startDate', //Custom
      label: 'Pickup Date',
      seq: 7
    },
    {
      field: 'starttime',
      label: 'Pick Up Time',
      seq: 8
    },
    {
      field: 'endlocation',
      label: 'Drop Off Address',
      seq: 9
    },
    {
      field: 'endDate', //Custom
      label: 'Dropoff Date',
      seq: 10
    },
    {
      field: 'endtime',
      label: 'Drop Off Time',
      seq: 11
    },
    {
      field: 'enddayoffset',
      label: '# of days',
      seq: 12
    },
    {
      field: 'attachments',
      label: 'Add Attachment',
      seq: 13
    },
    {
      field: 'confirmationnumber',
      label: 'Confirmation',
      seq: 14
    }
  ],
  // INF - Info
  INF: [
    {
      field: 'title',
      label: 'Title',
      seq: 1
    },
    {
      field: 'images',
      label: 'Add Image',
      seq: 2
    },
    {
      field: 'description',
      label: 'Description',
      seq: 3
    },
    {
      field: 'vendorlink',
      label: 'Link',
      seq: 4
    },
    {
      field: 'attachments',
      label: 'Add Attachment',
      seq: 5
    }
  ]
};

/**
 * Get field configuration for a specific service type
 * @param {string} serviceTypeCode - The service type code (HTL, ACT, CAR, FLT, RST, TRF, TRN, INF)
 * @returns {Array<Object>} Array of field definitions
 */
export const getLineItemFields = (serviceTypeCode) => {
  if (!serviceTypeCode || typeof serviceTypeCode !== 'string') {
    return [];
  }
  return (
    lineItemFieldConfig[
      /** @type {keyof typeof lineItemFieldConfig} */ (serviceTypeCode)
    ] || []
  );
};

/**
 * Get all required fields for a service type
 * @param {string} serviceTypeCode - The service type code
 * @returns {Array<Object>} Array of required field names
 */
export const getRequiredFields = (serviceTypeCode) => {
  const fields = getLineItemFields(serviceTypeCode);
  return fields
    .filter(
      (f) =>
        f &&
        typeof f === 'object' &&
        'required' in f &&
        'field' in f &&
        Boolean(f.required)
    )
    .map((f) => {
      return {
        field: String(/** @type {any} */ (f)?.field),
        label: String(/** @type {any} */ (f)?.label)
      };
    });
};

/**
 * Checkbox options for Meals Included field
 */
export const mealsIncludedOptions = [
  { label: 'Breakfast', value: 'Breakfast' },
  { label: 'Lunch', value: 'Lunch' },
  { label: 'Dinner', value: 'Dinner' }
];

/**
 * Sort meal options in consistent Breakfast - Lunch - Dinner order
 * @param {Array<string>|string} meals - Meal options (array or comma-separated string)
 * @returns {Array<string>} Sorted array of meal options
 */
export const sortMealOptions = (meals) => {
  if (!meals) return [];

  // Convert to array if it's a string
  const mealArray = Array.isArray(meals)
    ? meals.filter(Boolean)
    : meals
        .split(',')
        .map((m) => m.trim())
        .filter(Boolean);

  // Define the desired order
  const mealOrder = ['Breakfast', 'Lunch', 'Dinner'];

  // Sort based on the predefined order
  return mealArray.sort((a, b) => {
    const indexA = mealOrder.indexOf(a);
    const indexB = mealOrder.indexOf(b);

    // If meal is not in our predefined order, put it at the end
    if (indexA === -1 && indexB === -1) return a.localeCompare(b);
    if (indexA === -1) return 1;
    if (indexB === -1) return -1;

    return indexA - indexB;
  });
};

/**
 * @deprecated Use the new display components instead (see lineItemDisplayLayout deprecation notice above)
 *
 * Get preview field configuration for a specific service type
 * Merges display layout from lineItemDisplayLayout with field definitions from lineItemFieldConfig
 * Groups them by row and sorts by col
 * @param {string} serviceTypeCode - The service type code (HTL, ACT, CAR, FLT, RST, TRF, TRN)
 * @returns {Array<Array<Object>>} Array of rows, each containing field definitions for that row
 */
export const getLineItemPreviewFields = (serviceTypeCode) => {
  if (!serviceTypeCode || typeof serviceTypeCode !== 'string') {
    return [];
  }

  const allFields = getLineItemFields(serviceTypeCode);
  const displayLayout =
    lineItemDisplayLayout[
      /** @type {keyof typeof lineItemDisplayLayout} */ (serviceTypeCode)
    ];

  if (!displayLayout) {
    return [];
  }

  // Create a map of field definitions by field name for quick lookup
  const fieldMap = allFields.reduce(
    /** @param {Record<string, any>} acc */
    /** @param {any} field */
    (acc, field) => {
      if (field?.field) {
        /** @type {Record<string, any>} */ (acc)[field.field] = field;
      }
      return acc;
    },
    /** @type {Record<string, any>} */ ({})
  );

  // Build preview fields by merging display layout with field definitions
  const previewFields = Object.keys(displayLayout)
    .map((fieldName) => {
      const layoutConfig = /** @type {any} */ (displayLayout)[fieldName];
      const fieldDef = /** @type {Record<string, any>} */ (fieldMap)[fieldName];

      // If field doesn't exist in base config, create a virtual field definition
      // This handles calculated fields like checkInDate, checkOutDate
      if (!fieldDef) {
        return {
          field: fieldName,
          label: layoutConfig.label || fieldName,
          type: 'text', // Default type for virtual fields
          previewRow: layoutConfig.row,
          previewCol: layoutConfig.col,
          previewColsize: layoutConfig.colsize,
          previewLabel: layoutConfig.label,
          previewIcon: layoutConfig.icon,
          previewRenderAs: layoutConfig.renderAs
        };
      }

      // Merge field definition with display layout properties
      return {
        ...fieldDef,
        previewRow: layoutConfig.row,
        previewCol: layoutConfig.col,
        previewColsize: layoutConfig.colsize,
        previewLabel: layoutConfig.label || fieldDef.label,
        previewIcon: layoutConfig.icon,
        previewRenderAs: layoutConfig.renderAs
      };
    })
    .filter(Boolean);

  // Group by preview row
  const fieldsByRow = previewFields.reduce(
    /** @param {Record<number, any[]>} acc */
    /** @param {any} field */
    (acc, field) => {
      const row = field.previewRow;
      if (!acc[row]) acc[row] = [];
      acc[row].push(field);
      return acc;
    },
    /** @type {Record<number, any[]>} */ ({})
  );

  // Sort rows and fields within rows
  return Object.keys(fieldsByRow)
    .sort((a, b) => Number(a) - Number(b))
    .map((rowKey) => {
      return fieldsByRow[rowKey].sort(
        /**
         * @param {any} a
         * @param {any} b
         */
        (a, b) => {
          return a.previewCol - b.previewCol;
        }
      );
    });
};

/**
 * @deprecated Use getLineItemPreviewFields instead
 * Old preview config - kept for backward compatibility during migration
 */
export const lineItemPreviewConfig = {
  // HTL - Hotel/Accommodation
  HTL: [
    { field: 'vendorname', label: 'Hotel' },
    { field: 'vendorphone', label: 'Phone' },
    { field: 'startlocation', label: 'Address' },
    { field: 'enddayoffset', label: '# of Nights' },
    { field: 'serviceclass', label: 'Room' },
    { field: 'confirmationnumber', label: 'Confirmation' },
    { field: 'mealsincluded', label: 'Meals Included' },
    { field: 'vendorlink', label: 'Link' }
  ],

  // ACT - Activity
  ACT: [
    { field: 'vendorname', label: 'Provider', cols: 4 },
    { field: 'vendorphone', label: 'Contact Tel', cols: 4 },
    { field: 'startlocation', label: 'Address', cols: 4 },
    { field: 'starttime', label: 'Time', cols: 4 },
    { field: 'durationtime', label: 'Duration', cols: 4 },
    { field: 'vendorlink', label: 'Website', cols: 4, renderAs: 'link-only' }
  ],

  // CAR - Car Rental
  CAR: [
    { field: 'vendorname', label: 'Company' },
    { field: 'vendorphone', label: 'Phone' },
    { field: 'startlocation', label: 'Pick-up Location' },
    { field: 'endlocation', label: 'Drop-off Location' },
    { field: 'starttime', label: 'Pick-up Time' },
    { field: 'endtime', label: 'Drop-off Time' },
    { field: 'serviceclass', label: 'Car Type' },
    { field: 'confirmationnumber', label: 'Confirmation' }
  ],

  // FLT - Flight
  FLT: [
    { field: 'vendorname', label: 'Airline' },
    { field: 'servicenumber', label: 'Flight Number' },
    { field: 'startlocation', label: 'Departure Airport' },
    { field: 'endlocation', label: 'Arrival Airport' },
    { field: 'starttime', label: 'Departure Time' },
    { field: 'endtime', label: 'Arrival Time' },
    { field: 'serviceclass', label: 'Class' },
    { field: 'confirmationnumber', label: 'Confirmation' }
  ],

  // RST - Restaurant
  RST: [
    { field: 'vendorname', label: 'Restaurant' },
    { field: 'vendorphone', label: 'Phone' },
    { field: 'startlocation', label: 'Address' },
    { field: 'starttime', label: 'Time' },
    { field: 'confirmationnumber', label: 'Confirmation' },
    { field: 'vendorlink', label: 'Link' },
    { field: 'mealsincluded', label: 'Meals Included' }
  ],

  // TRF - Transfer
  TRF: [
    { field: 'vendorname', label: 'Company' },
    { field: 'contactname', label: 'Driver Name' },
    { field: 'vendorphone', label: 'Phone Number' },
    { field: 'startlocation', label: 'Pick-up Location' },
    { field: 'endlocation', label: 'Drop-off Location' },
    { field: 'starttime', label: 'Pick-up Time' },
    { field: 'endtime', label: 'Drop-off Time' },
    { field: 'confirmationnumber', label: 'Confirmation' }
  ],

  // TRN - Train
  TRN: [
    { field: 'vendorname', label: 'Train Company' },
    { field: 'servicenumber', label: 'Train Number' },
    { field: 'startlocation', label: 'Departure Station' },
    { field: 'endlocation', label: 'Arrival Station' },
    { field: 'starttime', label: 'Departure Time' },
    { field: 'endtime', label: 'Arrival Time' },
    { field: 'confirmationnumber', label: 'Confirmation' }
  ]
};
